import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1052d25c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./index.css?vue&type=style&index=0&id=1052d25c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1052d25c",
  null
  
)

export default component.exports